module.exports = ".navigation a {\r\n    text-align: left;\r\n  }"